import { render, staticRenderFns } from "./BasicSales.vue?vue&type=template&id=1ed65e5e"
import script from "./BasicSales.vue?vue&type=script&lang=js"
export * from "./BasicSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports